<template>
  <div>
    <Main
      ref="main"
      :loading="loading"
      :tableData="tableData"
      :disabled="disabled"
    >
      <div slot="header">
        <div class="d-flex align-items-center mb-2">
          <h6 style="color: #101010" class="mb-0">
            {{ $l('table_header_spec') || '规格报价' }}
          </h6>
          <el-divider direction="vertical" v-if="!disabled" />
          <b-button
            v-if="!disabled"
            size="sm"
            class="ml-2"
            variant="outline-success"
            @click="
              $refs.main.insertAt(
                (records = {
                  quotationMoqUnit: quotedUnit,
                  quotationMoqUnitText: quotedUnit,
                })
              )
            "
          >
            {{ $l('btn_addSpec') || '增加规格' }}
          </b-button>
        </div>
      </div>
    </Main>
  </div>
</template>
<script>
import Main from './main.vue'
import BaseTable from '@/mixins/base-table'
import { request } from '@/api/service'
export default {
  mixins: [BaseTable],
  components: { Main },
  props: {
    devTrackingQuotationNo: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      loading: false,
      quotedUnit: '',
      tableData: [],
    }
  },
  mounted() {
    this.getData()
    this.getQuotedUnit()
  },
  methods: {
    async getData() {
      if (!this.devTrackingQuotationNo) return
      this.loading = true
      const res = await this.$api
        .customerDevTrackingQuotationSampleListApi({
          devTrackingQuotationNo: this.devTrackingQuotationNo,
        })
        .catch(() => null)
      this.loading = false
      this.tableData = res?.body?.data
    },
    validate() {
      return this.$refs.main.validate()
    },
    getTableData() {
      return this.$refs.main.getTableData()
    },
    async getQuotedUnit() {
      const res = await request({
        url: '/master/common/dict/biz',
        method: 'POST',
        data: { dictType: 'quotedUnit' },
      }).catch(() => null)
      if (!res) return
      const { data } = res.body
      this.quotedUnit = data && data.length == 1 ? data[0].value : ''
    },
  },
}
</script>
